import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./SongDetailsPage.module.scss";
import {useSongDetailsPageLogic} from "./SongDetailsPage.logic";
import {SongDetailsTitleBar} from "./modules/title-bar/SongDetailsTitleBar";
import TabbedNavigation from "../../../../components/tabbedNavigation/TabbedNavigation";
import {SongDetailsLessonsList} from "./modules/lessons-list/SongDetailsLessonsList";
import {SongDetailsLessonDetails} from "./modules/lesson-details/SongDetailsLessonDetails";
import {SongDetailsLessonPreviewModal} from "./components/lesson-preview-modal/SongDetailsLessonPreviewModal";
import {WhenSongDetailsNotLoaded} from "./modules/conditional/song-details-not-loaded/WhenSongDetailsNotLoaded";
import LoadingAnimation2 from "../../../../components/loadingAnimation/LoadingAnimation2";
import {
  WhenSongDetailsLoadedWithoutLessons
} from "./modules/conditional/song-details-loaded-without-lessons/WhenSongDetailsLoadedWithoutLessons";
import {
  WhenSongDetailsLoadedWithLessons
} from "./modules/conditional/song-details-loaded-with-lessons/WhenSongDetailsLoadedWithLessons";
import {
  SongDetailsEmptyLessonResultsMessage
} from "./modules/song-details-empty-lesson-reults-message/SongDetailsEmptyLessonResultsMessage";

export const SongDetailsPage: VoidFunctionComponent = () => {
  const {isLessonIdSelected} = useSongDetailsPageLogic();
  return (
    <div className={s.songDetailsPage}>
      <WhenSongDetailsNotLoaded>
        <LoadingAnimation2/>
      </WhenSongDetailsNotLoaded>
      <WhenSongDetailsLoadedWithoutLessons>
        <SongDetailsTitleBar/>
        <SongDetailsEmptyLessonResultsMessage/>
      </WhenSongDetailsLoadedWithoutLessons>
      <WhenSongDetailsLoadedWithLessons>
        <SongDetailsLessonPreviewModal/>
        <SongDetailsTitleBar/>
        <main className={s.lessonContent}>
          <SongDetailsLessonsList useClassName={isLessonIdSelected ? s.mobileHidden : undefined}/>
          <div className={`${s.lessonControls} ${!isLessonIdSelected ? s.mobileHidden : ``}`}>
            <SongDetailsLessonDetails/>
          </div>
        </main>
      </WhenSongDetailsLoadedWithLessons>
      <footer className={s.footer}>
        <TabbedNavigation/>
      </footer>
    </div>
  );
}
